import { useQuery } from "@tanstack/react-query";
import type { ProviderStatisticsParams } from "./statisticsApi";
import { getProviderStatistics } from "./statisticsApi";

export function useProviderStatistics(providerId: string | null, params: ProviderStatisticsParams) {
  return useQuery({
    queryKey: ["admin", "statistics", "providers", providerId, params],
    queryFn: ({ signal }) => getProviderStatistics(providerId as string, params, signal),
    enabled: providerId !== null,
  });
}
